
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/variants/renters/a",
      function () {
        return require("private-next-pages/variants/renters/a.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/variants/renters/a"])
      });
    }
  